import { Guest } from '@/app/system/guest/Guest';
import emitter from '@/shared/services/emitter';

export class Notification implements Guest<string> {
  public constructor(private type: string) {}

  public receive(value: string): this {
    emitter.emit('createToast', {
      message: value,
      color: this.type,
    });
    return this;
  }

  public introduction(): 'guest' | 'patron' {
    return 'guest';
  }
}
